<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Operation Mode</h4>
        <el-form size="small"  label-position="left" class="fhv-form" label-width="180px" v-loading="loading"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="The current mode status：" v-if="$G_DEVICE_CFG.userType === '0'">
                {{ currentModeText }}
            </el-form-item>
            <el-form-item label="Change Mode:" v-if="$G_DEVICE_CFG.userType === '1'">
                <el-radio :label="4" v-model="systemMode" >Auto Mode</el-radio>
            </el-form-item>
            <el-form-item :label="$G_DEVICE_CFG.userType === '1' ? '': 'Change Mode:' ">
                <el-radio :label="1" v-model="systemMode" >Main Router Tagged mode</el-radio>
            </el-form-item>
            <el-form-item>
                <el-radio :label="2" v-model="systemMode" >Main Router Untagged mode</el-radio>
            </el-form-item>
            <el-form-item v-if="$G_DEVICE_CFG.userType === '1'">
                <el-radio :label="3" v-model="systemMode" >AP mode</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="dialogVisible = true" 
                :disabled="systemMode === systemModeCache">Apply</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            title="This devices will reset to default"
            :visible.sync="dialogVisible"
            width="30%">
            <p class="text-bold">Reboot</p>
            <p class="text-bold">Erase all configuration</p>
            <p class="text-ip" v-if="systemMode !== 3">Note: the management IP of new mdoe is {{mdoeIP}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="primary" @click="changeMode">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
    
</template>

<script>
import Reboot from '@/components/reboot.js'



export default {
    data() {
        return {
            loading:false,
            systemMode: 0,
            dialogVisible: false,
            systemModeCache: 0
        }
    },
    created(){
        this.getData()
    },
    computed: {
        mdoeIP() {
            return this.systemMode === 2 ? '192.168.10.1' : '192.168.1.1'
        },
        currentModeText(){
            const modeText = {
                '4' : 'Auto Mode',
                '1' : 'Main Router Tagged mode',
                '2' : 'Main Router Untagged mode',
                '3' : 'AP mode'
            }

            return modeText[this.systemModeCache] || 'Auto Mode'
        }
    },
    methods: {
        getData(){
            axios
            .post("/JSONAPI",{cmdType:"GET_SYSTEM_MODE"})
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    // 模式4 也是AUTO MODE
                    let mode = response.data.systemMode == 0 ? 1 : response.data.systemMode

                    this.systemMode = mode
                    this.systemModeCache = mode
                }
                else
                    this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        changeMode(){
            this.dialogVisible = false
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_SYSTEM_MODE",
                systemMode:this.systemMode
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    if(this.systemMode === 3)
                        Reboot.updata(this,`Mode switch successful! 
                                The device is restarting please wait...`)
                    else
                        Reboot.updata(this,`Mode switch successful! 
                                The device is restarting, please re-access using management IP(${this.mdoeIP}) later.`,
                                `http://${this.mdoeIP}`)
                }
                else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('SET data failed! Network connection error!')
            })
        }
    },
}
</script>

<style scoped>
.fhv-form{
    width: 100%;
}
.text-bold{
    font-weight: bold;
}
.text-ip{
    color: #E6A23C;
}
</style>